export default __webpack_public_path__ + "assets/icon-arrow-drop.ffe16c61.webp";